import App from './App'

// #ifndef VUE3
import Vue from 'vue'
import './uni.promisify.adaptor'
Vue.config.productionTip = false
App.mpType = 'app'
const app = new Vue({
  ...App
})
app.$mount()
// #endif

// #ifdef VUE3
import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'

// 引入 uni-ui 基础样式（H5 端需要）
import '@dcloudio/uni-ui/lib/uni-scss/index.scss'

// 引入 H5 端样式修复
// #ifdef H5
import './styles/uni-h5-fix.css'
import './styles/global-rpx-fix.css'  // 全局 rpx 修复
import './styles/native-input.css'    // 原生输入框样式
// #endif

export function createApp() {
  const app = createSSRApp(App)
  const pinia = createPinia()
  app.use(pinia)
  return {
    app
  }
}
// #endif